import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import SideBar from "../../other/SideBar";
import NavBar from "../../other/NavBar";
import LoadingModal from "../../../loader/LoadingModal";
import {
  AddRawMaterialURL,
  getFooderCountryURL,
  GetRawMaterialUnitListURL,

} from "../../../assets/api/BaseURL";
import Notification from "../../other/Notification";
import { useToast } from "../../../../context/ToastContext";

const AddRawMaterial = () => {
  const navigate = useNavigate();
  const { addToast } = useToast();
  const [token, setToken] = useState("");
  const [toggleSideBar, setToggleSideBar] = useState(false);
  const [canvas, setCanvas] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [measurementOptions, setMeasurementOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currencySymbol, setCurrencySymbol] = useState("");
  const [openingStockSubmit, setOpeningStockSubmit] = useState(false);
  const [openingStockCheckModel, setOpeningStockCheckModel] = useState(false);



  const [formData, setFormData] = useState({
    categoryType: "",
    measurementUnit: "",
    taxPercentage: "", // Changed from taxType to taxPercentage
    materialName: "",
    purchasePrice: "",
    salesPrice: "0",
    expiryDate: "",
    minimumStock: "",
    hsnCode: "",
    brand: "",
    conversionRate: "",
    consumptionUnit: "",
    status: true,
    description: "",
    expiryAlert: "",
    addToStock: true,
    openingStock: "0",
  });

  const handleToggleSidebar = (e) => {
    e.preventDefault();
    setToggleSideBar(!toggleSideBar);
  };

  const handleToggleOffCanvas = (e) => {
    e.preventDefault();
    setCanvas(!canvas);
  };

  const handleBackClick = (e) => {
    e.preventDefault();
    navigate("/raw_material");
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox" && name === "addToStock" && !checked) {
      setFormData((prevData) => ({
        ...prevData,
        [name]: checked,
        openingStock: "",
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
    setError("");
    setSuccess("");
  };

  function formatDate(inputDate) {
    const dateParts = inputDate.split("-");
    if (dateParts.length === 3) {
      const year = dateParts[0];
      const month = dateParts[1];
      const day = dateParts[2];

      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      const formattedDate = `${day} ${months[parseInt(month) - 1]} ${year}`;
      return formattedDate;
    }

    return inputDate;
  }

  const isValidNumber = (value) => {
    return !isNaN(parseFloat(value)) && isFinite(value);
  };

  const handleAddRawMaterial = async (e) => {
    if (e) {
      e.preventDefault();
    }

    console.log("formData")
    console.log(formData)


    if (formData.materialName === "") {
      setError("Material Name cannot be empty");
      setSuccess("");
    } else if (formData.categoryType === "") {
      setError("Category Type cannot be empty");
      setSuccess("");
    } else if (formData.measurementUnit === "") {
      setError("Intake Measurement Unit cannot be empty");
      setSuccess("");
    } else if (formData.consumptionUnit === "") {
      setError("Consumption Unit cannot be empty");
      setSuccess("");
    } else if (formData.conversionRate === "") {
      setError("Conversion Rate cannot be empty");
      setSuccess("");
    } else if (!isValidNumber(formData.conversionRate)) {
      setError("Please enter a valid Conversion Rate number");
      setSuccess("");
    } else if ((formData.conversionRate) < 0) {
      setError("Conversion rate number can't be negative");
      setSuccess("");
    }
    // Tax Percentage Validation (0 to 100, no negative) - Replaced Tax Type validation
    else if (formData.taxPercentage === "") {
      setError("Tax Percentage cannot be empty");
      setSuccess("");
    } else if (!isValidNumber(formData.taxPercentage)) {
      setError("Please enter a valid Tax Percentage number");
      setSuccess("");
    } else if (parseFloat(formData.taxPercentage) < 0) {
      setError("Tax Percentage cannot be negative");
      setSuccess("");
    } else if (parseFloat(formData.taxPercentage) > 100) {
      setError("Tax Percentage cannot exceed 100%");
      setSuccess("");
    }
    else if (formData.minimumStock === "") {
      setError("Minimum Stock cannot be empty");
      setSuccess("");
    } else if (!isValidNumber(formData.minimumStock)) {
      setError("Please enter a valid Minimum Stock number");
      setSuccess("");
    } else if ((formData.minimumStock) < 0) {
      setError("Minimum Stock number can't be negative");
      setSuccess("");
    } else if (formData.purchasePrice === "") {
      setError("Purchase Price cannot be empty");
      setSuccess("");
    } else if (!isValidNumber(formData.purchasePrice)) {
      setError("Please enter a valid Purchase Price");
      setSuccess("");
    } else if ((formData.purchasePrice) < 0) {
      setError("Purchase Price can't be negative");
      setSuccess("");
    } else if (formData.hsnCode === "" && selectedCountries === "IN") {
      setError("HSN Code cannot be empty");
      
      setSuccess("");
    }
    else if (formData.expiryAlert < 0) {
      setError("Expiry Alert Before(No. of Days) can't be negative");
      setSuccess("");
    } else if (formData.expiryAlert && !isValidNumber(formData.expiryAlert)) {
      setError("Please enter a valid No. of days for Expiry Alert");
      setSuccess("");
    } else if (formData.addToStock && formData.openingStock === "") {
      setError("Opening Stock cannot be empty");
      setSuccess("");
    } else if (formData.addToStock && !isValidNumber(formData.openingStock)) {
      setError("Please enter a valid Opening Stock number");
      setSuccess("");
    } else {
      const data = {
        material_name: formData.materialName,
        description: formData.description,
        category_id: formData.categoryType,
        measurement_unit_id: formData.measurementUnit,
        consumption_unit: formData.consumptionUnit,
        conversion_rate: formData.conversionRate,
        tax_percentage: parseFloat(formData.taxPercentage), // Changed from tax_id to tax_percentage
        minimum_stock: formData.minimumStock,
        purchase_price: formData.purchasePrice,
        sales_price: formData.salesPrice,
        hsn_code: formData.hsnCode,
        brand: formData.brand,
        expiry_date: formData.expiryDate ? formatDate(formData.expiryDate) : "",
        status: formData.status ? 1 : 0,
        expiry_alert_before: formData.expiryAlert,
        opening_stock: parseFloat(formData.openingStock) <= 0 ? 0 : parseFloat(formData.openingStock),
      };

      if (openingStockSubmit || parseFloat(formData.openingStock) > 0) {
        try {
          const response = await axios({
            method: "post",
            url: AddRawMaterialURL,
            data: data,
            headers: {
              "Content-Type": "application/json",
              authorization: `Bearer ${token}`,
            },
          });
          setOpeningStockCheckModel(false)
          setOpeningStockSubmit(false)

          if (response.status === 200 && response.data.message) {
            setError("");
            setSuccess(response.data.message);
            setFormData({
              categoryType: "",
              measurementUnit: "",
              taxPercentage: "", // Reset tax percentage
              materialName: "",
              purchasePrice: "",
              salesPrice: "0",
              expiryDate: "",
              minimumStock: "",
              hsnCode: "",
              brand: "",
              conversionRate: "",
              consumptionUnit: "",
              status: true,
              description: "",
              expiryAlert: "",
              addToStock: true,
              openingStock: "",
            });
          }
        } catch (error) {
          setOpeningStockCheckModel(false)
          setOpeningStockSubmit(false)
          if (error.response && error.response.data.message) {
            setError(error.response.data.message);
            setSuccess("");
          } else {
            setError(error.message);
            setSuccess("");
          }
          console.log(error);
        }
      } else {
        if (parseFloat(formData.openingStock) <= 0) {
          setOpeningStockCheckModel(true)
        }
      }
    }
  };

  useEffect(() => {
    if (!localStorage.getItem("token")) {
      navigate("/auth");
    }
  }, [navigate]);

  useEffect(() => {
    setToken(localStorage.getItem("token"));
  }, [token]);


  useEffect(() => {
    if (localStorage.getItem("currencySymbol")) {
      setCurrencySymbol(localStorage.getItem("currencySymbol"));
    }
  }, []);

  useEffect(() => {
    if (token) {
      async function getData() {
        setIsLoading(true);
        try {
          const response = await axios.get(GetRawMaterialUnitListURL, {
            headers: { authorization: `Bearer ${token}` },
          });

          if (response.status === 200 && response.data) {
            setCategoryOptions(response.data.rawMaterialsCategoryList);
            setMeasurementOptions(response.data.measurementUnitList);
            // Removed taxOptions since we're not using tax type dropdown anymore
          }
        } catch (error) {
          if (error.response && error.response.data.message) {
            addToast("error", error.response.data.message);
          } else {
            addToast("error", error.message);
          }
          console.log(error);
        }
        setIsLoading(false);
      }
      getData();
    }
  }, [token, addToast]);

  useEffect(() => {
    if (error || success) {
      window.scrollTo(0, 0);
    }
  }, [error, success]);

  useEffect(() => {
    if (openingStockSubmit) {
      handleAddRawMaterial()

    }
  }, [openingStockSubmit]);









  const [selectedCountries, setSelectedCountry] = useState([]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {

        // 2️⃣ Get selected country (single object)
        const selectedRes = await axios.get(getFooderCountryURL, {
          headers: { authorization: `Bearer ${localStorage.getItem("token")}` },
        });

        if (selectedRes.data.status === "success" && selectedRes.data.data) {
          const selectedCountryCode = selectedRes.data.data.country;
          setSelectedCountry(selectedCountryCode)
        }

      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, []);


















  return (
    <>
      {token && (
        <>
          <div
            className={
              toggleSideBar
                ? "container-scroller sidebar-icon-only"
                : "container-scroller"
            }
          >
            <nav className="navbar default-layout col-lg-12 col-12 p-0 fixed-top d-flex align-items-top flex-row">
              <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-start">
                <Link className="navbar-brand brand-logo-mini" to="/fooders_cp">
                  {/* <img src="images/mini-kr-logo.svg" alt="logo" />     */}
                </Link>
                <div className="me-1">
                  <button
                    className={
                      toggleSideBar
                        ? "navbar-toggler navbar-toggler align-self-center"
                        : "navbar-toggler navbar-toggler align-self-center text-white"
                    }
                    type="button"
                    onClick={handleToggleSidebar}
                  >
                    <span className="icon-menu"></span>
                  </button>
                </div>
                <div>
                  <Link to="/fooders_cp">
                    <span className="navbar-brand brand-logo">
                      <img src="images/vyfoo_logo.png" alt="logo" />
                    </span>
                  </Link>
                </div>
              </div>
              <NavBar handleToggle={handleToggleOffCanvas} toggleCanvas={toggleSideBar} />
            </nav>
            <div className="container-fluid page-body-wrapper px-0">
              <SideBar active="raw_material" toggleCanvas={toggleSideBar} />

              <div className="main-panel">

                {openingStockCheckModel &&

                  <div className="popup-modal">
                    <div className="popup-modal-content">
                      <h4 className="content">The Default Value of Opening Stock is 0. <br />Do you want to proceed ?</h4>
                      <div className="popup_btn_container">
                        <button className="btn btn-primary me-2" onClick={() => { setOpeningStockSubmit(true) }}>Yes</button>
                        <button className="btn btn btn-secondary" onClick={() => { setOpeningStockCheckModel(false) }}>No</button>
                      </div>
                    </div>
                  </div>
                }


                <div className="content-wrapper">
                  <div className="row">
                    <div className="col-sm-12">
                      <h3 className="ukhd mb-3">Ingredients</h3>
                      <div className="row flex-grow">
                        <div className="col-12 grid-margin stretch-card">
                          <div className="card card-rounded">
                            <div className="card-body">
                              <div className="d-flex justify-content-between align-items-start mb-2">
                                <div className="vsalign">
                                  <h4 className="card-title card-title-dash">
                                    Add Ingredient
                                  </h4>
                                </div>
                                <div className="vsalign">
                                  <span
                                    className="btn btn-danger mb-0 me-0"
                                    onClick={handleBackClick}
                                  >
                                    <i className="menu-icon mdi mdi-arrow-left vsalign"></i>
                                    Go Back
                                  </span>
                                </div>
                              </div>
                              <form className="forms-sample">
                                {error && (
                                  <div className="d-flex justify-content-between align-items-start alert alert-danger">
                                    <div className="vsalign">{error}</div>
                                    <div className="vsalign">
                                      <span
                                        className=".h3 text-muted"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => setError("")}
                                      >
                                        x
                                      </span>
                                    </div>
                                  </div>
                                )}
                                {success && (
                                  <div className="d-flex justify-content-between align-items-start alert alert-success">
                                    <div className="vsalign">{success}</div>
                                    <div className="vsalign">
                                      <span
                                        className=".h3 text-muted"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => setSuccess("")}
                                      >
                                        x
                                      </span>
                                    </div>
                                  </div>
                                )}

                                <div className="row">
                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <label>
                                        Material Name
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Material Name"
                                        name="materialName"
                                        value={formData.materialName}
                                        onChange={handleInputChange}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <label>
                                        Select Category Type
                                        <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-select"
                                        name="categoryType"
                                        value={formData.categoryType}
                                        onChange={handleInputChange}
                                      >
                                        <option value="">
                                          Select Category Type
                                        </option>
                                        {categoryOptions.map((item) => (
                                          <option key={item.id} value={item.id}>
                                            {item.category_name}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <label>Description</label>
                                      <textarea
                                        className="form-control"
                                        placeholder="Enter Description"
                                        rows="1"
                                        name="description"
                                        value={formData.description}
                                        onChange={handleInputChange}
                                      ></textarea>
                                    </div>
                                  </div>

                                  {/* Tax Percentage Input - Replaced the Tax Type dropdown */}
                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <label>
                                        Tax Percentage (%)
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Enter Tax Percentage (0-100)"
                                        name="taxPercentage"
                                        value={formData.taxPercentage}
                                        onChange={handleInputChange}
                                        min="0"
                                        max="100"
                                        step="any"
                                        onKeyDown={(e) => {
                                          // Prevent negative values and 'e' character
                                          if (e.key === '-' || e.key === 'e') {
                                            e.preventDefault();
                                          }
                                        }}
                                        onInput={(e) => {
                                          // Additional validation to ensure value stays within range
                                          let value = parseFloat(e.target.value);
                                          if (value < 0) e.target.value = 0;
                                          if (value > 100) e.target.value = 100;
                                        }}
                                      />
                                      <small className="text-muted">Enter value between 0 and 100</small>
                                    </div>
                                  </div>

                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <label>
                                        Minimum Stock
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Minimum Stock"
                                        name="minimumStock"
                                        value={formData.minimumStock}
                                        onChange={handleInputChange}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <label>
                                        Purchase Price
                                        <span className="text-danger">*</span>
                                      </label>
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Purchase Price"
                                          name="purchasePrice"
                                          value={formData.purchasePrice}
                                          onChange={handleInputChange}
                                        />
                                        <span className="input-group-text">
                                          {currencySymbol}
                                        </span>
                                      </div>
                                    </div>
                                  </div>

                                  {selectedCountries === "IN" ? <>
                                  
                                    <div className="col-lg-4">
                                    <div className="form-group">
                                      <label>
                                        HSN Code
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter HSN Code"
                                        name="hsnCode"
                                        value={formData.hsnCode}
                                        onChange={handleInputChange}
                                      />
                                    </div>
                                  </div>
                                  
                                  </> : <></>}
                                
                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <label>
                                        Brand
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Brand"
                                        name="brand"
                                        value={formData.brand}
                                        onChange={handleInputChange}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <label>
                                        Intake Measurement Unit
                                        <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-select"
                                        name="measurementUnit"
                                        value={formData.measurementUnit}
                                        onChange={handleInputChange}
                                      >
                                        <option value="" disabled={true}>
                                          Select Measurement Unit
                                        </option>
                                        {measurementOptions.map((item) => (
                                          <option key={item.id} value={item.id}>
                                            {item.unit_name}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <label>
                                        Consumption Unit
                                        <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-select"
                                        name="consumptionUnit"
                                        value={formData.consumptionUnit}
                                        onChange={handleInputChange}
                                      >
                                        <option value="" disabled={true}>
                                          Select Measurement Unit
                                        </option>
                                        {measurementOptions.map((item) => (
                                          <option key={item.id} value={item.id}>
                                            {item.unit_name}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <label>
                                        Conversion Rate
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Conversion Rate"
                                        name="conversionRate"
                                        value={formData.conversionRate}
                                        onChange={handleInputChange}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <label>
                                        Expiry Alert Before(No. of Days)
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter No. of Days"
                                        name="expiryAlert"
                                        value={formData.expiryAlert}
                                        onChange={handleInputChange}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-4">
                                    {formData.addToStock && (
                                      <>
                                        <div className="form-group mt-2">
                                          <label className="form-check-label">
                                            Opening Stock
                                            <span className="text-danger">*</span>
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Opening Stock"
                                            name="openingStock"
                                            value={formData.openingStock}
                                            onChange={handleInputChange}
                                          />
                                        </div>
                                      </>
                                    )}
                                  </div>
                                  <div className="col-lg-4">
                                    <div className="form-group togglecss">
                                      <label>Status</label>
                                      <div className="button r" id="button-1">
                                        <input
                                          type="checkbox"
                                          className="checkbox"
                                          name="status"
                                          checked={formData.status}
                                          onChange={handleInputChange}
                                        />
                                        <div className="knobs"></div>
                                        <div className="layer"></div>
                                      </div>
                                    </div>
                                  </div>

                                  <label className="text-danger form-group">
                                    Please fill these fields (Intake Measurement Unit, Consumption Unit, and Conversion Rate) very carefully, these fields will not change in future.
                                  </label>


                                </div>

                                <button
                                  type="submit"
                                  className="btn btn-primary me-2"
                                  onClick={handleAddRawMaterial}
                                >
                                  Submit
                                </button>
                                <button
                                  className="btn btn btn-secondary"
                                  onClick={handleBackClick}
                                >
                                  Cancel
                                </button>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <LoadingModal isLoading={isLoading} />

          <Notification />
        </>
      )}
    </>
  );
};

export default AddRawMaterial;